import React, { useEffect } from 'react';
import useBootstrap from '../hooks/useBootstrap';

export const BootstrapHandler: React.FC = () => {
    const bootstrap = useBootstrap();

    useEffect(() => {
        bootstrap.fetch();
    }, []);

    return null;
};
